import BottomShine from "../../assets/img/subject_underline_shine_effect.png";
import AppModal from "../AppModal";
import React, {useCallback, useState} from "react";
import {submitSocialItem} from "../../helpers/photoboothHelpers";
import {ItemTypes} from "../../constants";


const SocialWallMessageModal = props => {

    const {setShowModerateMessageDialog} = props;
    const {showAddMessageDialog, setShowAddMessageDialog} = props;
    const [newMessage, setNewMessage] = useState('');

    const styles = {
        dialogContent: {
            display: 'grid',
            alignItems: 'center',
            position: 'relative',
            margin: '20px 0 0 0',
            width: '80%'
        },
        dialogInput: {
            background: 'transparent',
            color: 'white',
            fontSize: '1em',
            width: '100%',
            height: '100%'
        },
        sendMessageBtn: {
            cursor: 'pointer',
            color: 'white',
            padding: '0.5vw 2vw',
            backgroundColor: 'transparent',
            border: 'none',
            borderRadius: '5px',
            fontSize: '1.1vw',
            fontFamily: 'DINPro-Bold',
        },
        dialogButton: {}
    };

    const dialogStyle = {
        content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            width: '30vw',
            maxWidth: '30vw',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
            border: '0px',
            background: '',
            padding: "3px 3px",
            textAlign: "center",
            backgroundSize: "100% 100%",
            alignItems: "center",
            overflow: "hidden",
        },
        overlay: {
            zIndex: 900,
        }
    };

    const handleMessageChange = useCallback(e => {
        setNewMessage(e.target.value.slice(0, 25))
    }, [])

    const handleAddMessage = useCallback(() => {
        submitSocialItem(newMessage, ItemTypes.MESSAGE)
            .then(() => {
                setNewMessage('')
                setShowAddMessageDialog(false);
                setShowModerateMessageDialog(true);
            })
    }, [newMessage])

    return(
        <AppModal isOpen={showAddMessageDialog}
                  handleCloseModal={() => setShowAddMessageDialog(false)}
                  propsStyle={dialogStyle}
                  contents={
                      <div className={'modal-content-help'}>
                          <div className={'modal-header'}>
                              <h4 style={{fontSize: '1.1vw', margin: 7}}>Social Wall Message</h4>
                              <div className={'close-button-help'}
                                   onClick={() => setShowAddMessageDialog(false)}>X
                              </div>
                          </div>
                          <div style={{display: 'flex', width: '140%'}}>
                              <img src={BottomShine} style={{height: 5, width: '100%'}} alt={''}/>
                          </div>
                          <div style={styles.dialogContent} >
                               <textarea
                                    rows={5}
                                    color={20}
                                     value={newMessage}
                                     onChange={handleMessageChange}
                                     placeholder="Enter your message here.."
                                     style={styles.dialogInput}/>
                          </div>
                          <div>
                              <button onClick={handleAddMessage} style={styles.sendMessageBtn} >Send</button>
                          </div>
                      </div>}
        />
    )
}

export default SocialWallMessageModal;